import React from 'react';
import { useSelector } from 'react-redux';

import i18n from 'util/i18n';
import { FINANCIAL } from 'config/formSections/financial';

import SectionIntro from 'components/Section/shared/SectionIntro';
import { isPVQForm } from 'helpers/form';
import { rootSelectors } from '@redux/modules/selectors';

const Intro = function () {
  const formType = useSelector(rootSelectors.application.getFormType);
  const isPVQ = isPVQForm(formType);
  const bulletArray = [i18n.t('financial.pvq.intro.bullet1'), i18n.t('financial.pvq.intro.bullet2'), i18n.t('financial.pvq.intro.bullet3')];

  return isPVQ ? (
    <SectionIntro
      title={i18n.t('financial.pvq.intro.title')}
      body={i18n.m('financial.pvq.intro.body')}
      bullets={bulletArray}
      sectionKey={FINANCIAL.key}
    />
  ) : (
    <SectionIntro
      title={i18n.t('financial.intro.title')}
      body={i18n.m('financial.intro.body')}
      sectionKey={FINANCIAL.key}
    />
  );
};

export default Intro;
